import React from 'react'

export const parseBoldText = (text: string, boldClassName?: string) => {
  if (!text) return null

  const parts = text.split('*')
  return parts.map((part, index) => {
    // Odd indices are text between asterisks (should be bold)
    if (index % 2 === 1) {
      return (
        <span key={index} className={boldClassName} style={boldClassName ? undefined : { fontWeight: 700 }}>
          {part}
        </span>
      )
    }
    return <React.Fragment key={index}>{part}</React.Fragment>
  })
}
